/* eslint-disable no-shadow */
/* eslint-disable react/no-unstable-nested-components */
import { useCallback, useState } from 'react';
import { Select } from 'antd-v5';
import { connect } from 'react-redux';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import useGetClients from '../../../hooks/query/useGetClients';
import useDebounce from '../../../hooks/useDebounce';

export const SearchClientsInputV2 = ({ posType, stores, placeholder = 'Search client by name', onSelect }) => {
  const [value, setValue] = useState(null);
  const [search, setSearch] = useState('');
  const debounceSearch = useDebounce(search);

  const {
    data: { data: results },
    isLoading,
    isFetching,
  } = useGetClients({
    data: {
      searchTerm: debounceSearch,
      offset: 0,
      limit: 10,
      storeId: 0,
      archived: false,
    },
    loadingStatusOff: true,
  });

  const handleSelect = useCallback(
    id => {
      setValue(id);
      const selectedOption = results.find(e => e.id.toString() === id);
      onSelect(selectedOption);
    },
    [results],
  );

  return (
    <Select
      filterOption={false}
      className="w-100-P"
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      onSearch={value => setSearch(value)}
      prefix={<SearchOutlined />}
      suffixIcon={isFetching && !isLoading ? <LoadingOutlined /> : null}
      showSearch
      onSelect={handleSelect}
      searchValue={search}
      value={value}
      notFoundContent={isFetching ? <LoadingOutlined /> : null}
      options={results?.map(item => ({
        value: item?.id?.toString(),
        label: item?.name || item?.preferred_name || item?.mobile,
        suffix: (posType ? item?.pos_ref_num : item?.mobile) || item?.mobile,
      }))}
      optionRender={option => {
        return (
          <div className="flex-row-nospacebetween-nowrap">
            <div>{option.label}</div>
            {option?.data?.suffix && option?.data?.suffix !== 'null' && option?.data?.suffix !== '' && (
              <span className="m-left-4 opacity-50 italic fs-12">({option.data.suffix})</span>
            )}
          </div>
        );
      }}
    />
  );
};

const mapStateToProps = state => ({
  posType: state.auth.pos_type,
  stores: state.auth.stores,
});

export default connect(mapStateToProps, {})(SearchClientsInputV2);
